import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-95" data-mp="3gfitoga0y7d2">
    <div className="glass-panel p-8 md:p-12 rounded-3xl text-center border-brand-purple/40 bg-white/85 shadow-sm" data-id="element-96" data-mp="3ggk72reij5xy">
      <Shield className="w-14 h-14 md:w-16 md:h-16 text-brand-purple mx-auto mb-6" data-id="element-97" data-mp="32lrmvfnoh1l1" />
      <h2 className="text-xl md:text-3xl font-display font-bold mb-4 text-brand-purpleDark" data-id="element-98" data-mp="36ppl7o56i8d1">
        🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
      </h2>
      <p className="text-brand-text mb-4 text-base md:text-lg" data-id="element-99" data-mp="39922nzchmct">
        Abrís los tomos. Aplicás los protocolos. Los usás en tu consultorio.
      </p>
      <p className="text-brand-text mb-6 text-base md:text-lg" data-id="element-100" data-mp="3le2katzkc7br">
        Si en 7 días no es lo que esperabas: devolución del 100% sin
        formularios, sin drama.
      </p>
      <p className="font-medium text-brand-purple text-sm md:text-base" data-id="element-101" data-mp="29ydvdx2r0y8b">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-purpleDark text-white/85 py-12 border-t border-brand-gold/20" data-id="element-102" data-mp="3l8qupznvcbpc">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-103" data-mp="3gaz2t5n84pl5">
      <div className="mb-8" data-id="element-104" data-mp="3v7q63q00qlg1">
        <h3 className="font-display font-bold text-2xl text-brand-goldLight mb-2" data-id="element-105" data-mp="3v7zy1j4mj2od">
          🌿 LUMEN AKASHA™
        </h3>
        <p className="text-white/75" data-id="element-106" data-mp="3q7u2hrv8gw10">
          El sistema clínico N°1 para terapeutas de fitoterapia nativa en
          Argentina.
        </p>
        <p className="text-white/75 mt-2" data-id="element-107" data-mp="33xdnwzdzwrz">
          Porque trabajar con las plantas de esta tierra con excelencia no
          debería costarte la seguridad de tu consultorio.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-sm" data-id="element-108" data-mp="ctqo2unsm5un">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors" data-id="element-109" data-mp="qsqea6qyessx">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors" data-id="element-110" data-mp="tvmodc6um6j9">
          📲 @lumen.akasha
        </a>
        <a href="tel:+541153399780" className="hover:text-brand-goldLight transition-colors" data-id="element-111" data-mp="13tajw4ca3i2h">
          📲 11 5339-9780
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors" data-id="element-112" data-mp="18lbuzmxpn2qx">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-white/50 space-y-2" data-id="element-113" data-mp="1hj4aar3fmaeb">
        <p data-id="element-114" data-mp="1mj8tiovq5j88">
          © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
        <p data-id="element-115" data-mp="1rgsfyc2kt2b9">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
      </div>

      <div className="mt-8" data-id="element-116" data-mp="3od841810vwjv">
        <p className="text-sm font-serif italic text-brand-goldLight/70" data-id="element-117" data-mp="3t9yhropcug24">
          🌿 "El terapeuta que tiene un sistema, aplica con confianza. El que
          aplica con confianza, genera resultados. El que genera resultados,
          crece."
        </p>
      </div>
    </div>
  </footer>;